import { configureStore } from '@reduxjs/toolkit';
//client
import clientCodeReducer from './slices/clientCodeSlice';
//map
import currentCoordinatesReducer from './slices/currentCoordinatesSlice';
import mapIframeIdReducer from './slices/mapIframeIdSlice';
import currentCoordinatesToggleValueReducer from './slices/currentCoordinatesToggleValueSlice';
import currentRotationAmountReducer from './slices/currentRotationAmountSlice';
import mapCenterReducer from './slices/mapCenterCoordinatesSlice';
import mapZoomLevelReducer from './slices/mapZoomLevelSlice';
import currentMaxZoomReducer from './slices/currentMaxZoomSlice';
import currentZoomLevelReducer from './slices/currentZoomLevelSlice';
import isDecreaseZoomControlAmountReducer from './slices/isDecreaseZoomControlAmount';
import isMapLockedReducer from './slices/isMapLockedSlice';
import mapLayersReducer from './slices/mapLayersSlice';
import mapTileUrlReducer from './slices/mapTileUrlSlice';
import isUsingMeasuringToolReducer from './slices/isUsingMeasuringToolSlice';
import isHideMapTilesReducer from './slices/isHideMapTilesSlice';
import isCanAccessMapTileLayerReducer from './slices/isCanAccessMapTileLayer';
import isSendAnimationEndReducer from './slices/isSendAnimationEndSlice';
import isModalOpenReducer from './slices/isModalOpenSlice';
import modalBodyReducer from './slices/modalBodySlice';
import mapDetailsBodyReducer from './slices/mapDetailsBodySlice';
import mapOptionsReducer from './slices/mapOptionsSlice';
import isMeasuringToolDeleteClickedReducer from './slices/isMeasuringToolDeleteClickedSlice';
import isSlopeServiceActiveReducer from './slices/isSlopeServiceActive';
import isEditingZoomReducer from './slices/isEditingZoomSlice';
import isMapZoomingReducer from './slices/isMapZoomingSlice';
import isRegionDataLoadingReducer from './slices/isRegionDataLoadingSlice';
import isShowRegionLayersReducer from './slices/isShowRegionLayersSlice';
import isShowDetailsButtonReducer from './slices/isShowDetailsButtonSlice';
import isOnMapClickReducer from './slices/isOnMapClickSlice';

//edit authorization
import isAuthorizedToEditReducer from './slices/isAuthorizedToEditSlice';
import isEditableReducer from './slices/isEditableSlice';
import isEditingMainPolygonReducer from './slices/isEditingMainPolygonSlice';
import isDrawPolygonActiveReducer from './slices/isDrawPolygonActiveSlice';
import isDrawingPolygonReducer from './slices/isDrawingPolygonSlice';
//delete actions
import deletedLayerIDsReducer from './slices/deletedLayerIDsSlice';
//------drawn polygon
import isEditDrawnPolygonsReducer from './slices/isEditDrawnPolygonSlice';
import editedDrawnPolygonInfoReducer from './slices/editedDrawnPolygonInfoSlice';
import deletedDrawnPolygonIdReducer from './slices/deletedDrawnPolygonIdSlice';
//single polygon
import singlePolygonCoordinatesReducer from './slices/singlePolygonCoordinatesSlice';
import singlePolygonCenterCoordinatesReducer from './slices/singlePolygonCenterCoordsSlice';
import isShowBreakpointsReducer from './slices/isShowBreakpointsSlice';
import isShowPolygonBreakpointsReducer from './slices/isShowPolygonBreakpointsSlice';
import isBreakpointsButtonActiveReducer from './slices/isBreakpointsButtonActiveSlice';
import isPolygonDragActiveReducer from './slices/isPolygonDragActive';
//multi polygons
import multiPolygonsInfoReducer from './slices/multiPolygonsInfoSlice';
import actionsButtonsReducer from './slices/actionsButtonsSlice';
// import gardensPolygonsObjectReducer from './slices/gardensPolygonsObjectSice';
import multiPolygonEditedIDReducer from './slices/multiPolygonEditedIDSlice';
import multiPolygonEditedCoordsReducer from './slices/multiPolygonEditedCoordsSlice';
import isUsePolygonClusterReducer from './slices/isUsePolygonClusterSlice';
import polygonClusterMinimumDisplayZoomReducer from './slices/polygonClusterMinimumDisplayZoomSlice';
//polyline
import distanceToPolygonInfoReducer from './slices/distanceToPolygonInfoSlice';
import isDrawPolylineActiveReducer from './slices/isDrawPolylineActive';
import polylineDistanceTooltipCoordsReducer from './slices/PolylineDistanceTooltipCoordsSlice';
import updatePolylineDistanceTooltipCoordsReducer from './slices/PolylineDistanceTooltipCoordsSlice';
//marker
import markerCoordinatesReducer from './slices/markerCoordinatesSlice';
import markersInfoReducer from './slices/markersInfoSlice';
import regionMarkersInfoReducer from './slices/regionMarkersInfoSlice';
//generated points
import distanceBetweenGeneratedPointsReducer from './slices/distanceBetweenGeneratedPointsSlice';
import gridRegionCoordsReducer from './slices/gridRegionPolygonCoordinatesSlice';
import squareGridCoordinatesReducer from './slices/squareGridCoordinatesSlice';
import countryGridCoordinatesReducer from './slices/countryGridCoordinatesSlice';
//earth engine service
import isEarthEngineServiceActiveReducer from './slices/isEarthEngineServiceActiveSlice';
import earthEngineAreaOfInterestPolygonCoordsReducer from './slices/earthEngineAreaOfInterestPolygonCoordsSlice';

/*generating potential paths that cause serializable error*/
const ignoredPathsArray: string[] = [];
for (let i = 0; i < 40; i++) {
    ignoredPathsArray.push(
        'polylineDistanceTooltipCoords.value.' + i + '.coords.0',
        'updatePolylineDistanceTooltipCoords.value.' + i + '.coords.0',
        'polylineDistanceTooltipCoords.value.' + i + '.coords.1',
        'updatePolylineDistanceTooltipCoords.value.' + i + '.coords.1',
        'multiPolygonEditedCoords.value.' + i,
        'gridRegionCoordinates.value.' + i,
        `earthEngineAreaOfInterestPolygonCoords.value.` + i,
        `payload.` + i,
    );
}
export const store = configureStore({
    reducer: {
        //------client code
        clientCode: clientCodeReducer,
        //------map
        currentCoords: currentCoordinatesReducer,
        mapIframeId: mapIframeIdReducer,
        currentCoordsToggleValue: currentCoordinatesToggleValueReducer,
        currentRotationAmount: currentRotationAmountReducer,
        mapCenterCoords: mapCenterReducer,
        mapZoomLevel: mapZoomLevelReducer,
        currentMaxZoom: currentMaxZoomReducer,
        currentZoomLevel: currentZoomLevelReducer,
        isDecreaseZoomControlAmount: isDecreaseZoomControlAmountReducer,
        isMapLocked: isMapLockedReducer,
        mapLayers: mapLayersReducer,
        mapTileUrl: mapTileUrlReducer,
        isUsingMeasuringTool: isUsingMeasuringToolReducer,
        isMeasuringToolDeleteClicked: isMeasuringToolDeleteClickedReducer,
        isHideMapTiles: isHideMapTilesReducer,
        isCanAccessMapTileLayer: isCanAccessMapTileLayerReducer,
        isSendAnimationEnd: isSendAnimationEndReducer,
        isModalOpen: isModalOpenReducer,
        modalBody: modalBodyReducer,
        mapDetailsBody: mapDetailsBodyReducer,
        mapOptions: mapOptionsReducer,
        isSlopeServiceActive: isSlopeServiceActiveReducer,
        isEditingZoom: isEditingZoomReducer,
        isMapZooming: isMapZoomingReducer,
        isRegionDataLoading: isRegionDataLoadingReducer,
        isShowRegionLayers: isShowRegionLayersReducer,
        isShowDetailsButton: isShowDetailsButtonReducer,
        isOnMapClick: isOnMapClickReducer,

        actionsButtons: actionsButtonsReducer,
        //------draw button activation
        isDrawPolylineActive: isDrawPolylineActiveReducer,
        isDrawPolygonActive: isDrawPolygonActiveReducer,
        //------edit authorization
        isAuthorizedToEdit: isAuthorizedToEditReducer,
        isEditable: isEditableReducer,
        isEditingMainPolygon: isEditingMainPolygonReducer,
        isDrawingPolygon: isDrawingPolygonReducer,
        //------delete actions
        deletedLayerIDs: deletedLayerIDsReducer,
        //------drawn polygon
        isEditDrawnPolygons: isEditDrawnPolygonsReducer,
        editedDrawnPolygonInfo: editedDrawnPolygonInfoReducer,
        deletedDrawnPolygonId: deletedDrawnPolygonIdReducer,
        //------single polygon
        singlePolygonCoords: singlePolygonCoordinatesReducer,
        singlePolygonCenterCoords: singlePolygonCenterCoordinatesReducer,
        isShowBreakpoints: isShowBreakpointsReducer,
        isBreakpointsButtonsActive: isBreakpointsButtonActiveReducer,
        isShowPolygonBreakpoints: isShowPolygonBreakpointsReducer,
        isPolygonDragActive: isPolygonDragActiveReducer,
        //------multi polygons
        multiPolygonsInfo: multiPolygonsInfoReducer,
        polygonClusterMinDisplayZoom: polygonClusterMinimumDisplayZoomReducer,
        isUsePolygonCluster: isUsePolygonClusterReducer,
        // gardensPolygonsObject: gardensPolygonsObjectReducer,
        multiPolygonEditedID: multiPolygonEditedIDReducer,
        multiPolygonEditedCoords: multiPolygonEditedCoordsReducer,
        //------polyline
        distanceToPolygonInfo: distanceToPolygonInfoReducer,
        polylineDistanceTooltipCoords: polylineDistanceTooltipCoordsReducer,
        updatePolylineDistanceTooltipCoords: updatePolylineDistanceTooltipCoordsReducer,
        //------marker
        markerCoordinates: markerCoordinatesReducer,
        markersInfo: markersInfoReducer,
        regionMarkersInfo: regionMarkersInfoReducer,
        //------generated points
        distanceBetweenGeneratedPoints: distanceBetweenGeneratedPointsReducer,
        gridRegionCoordinates: gridRegionCoordsReducer,
        squareGridCoordinates: squareGridCoordinatesReducer,
        countryGridCoordinates: countryGridCoordinatesReducer,
        //------earth engine service
        isEarthEngineServiceActive: isEarthEngineServiceActiveReducer,
        earthEngineAreaOfInterestPolygonCoords: earthEngineAreaOfInterestPolygonCoordsReducer,
    },
    /*middleware for serializable error fix*/
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            serializableCheck: {
                ignoredActionPaths: ['payload.coords.0', 'payload.coords.1'],
                ignoredPaths: ignoredPathsArray,
            },
        }),
    ],
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
